import { FC, SVGProps } from 'react';

export const BlastAddonIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='19' height='19' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<rect y='0.5' width='18.0804' height='18' rx='9' fill='url(#paint0_radial_7173_265)' />
		<g filter='url(#filter0_d_7173_265)'>
			<path
				d='M9.04032 4.35718C9.11784 7.16476 11.3756 9.42251 14.1832 9.50003C11.3756 9.57756 9.11784 11.8353 9.04032 14.6429C8.9628 11.8353 6.70504 9.57756 3.89746 9.50003C6.70504 9.42251 8.9628 7.16476 9.04032 4.35718Z'
				fill='url(#paint1_radial_7173_265)'
			/>
		</g>
		<defs>
			<filter
				id='filter0_d_7173_265'
				x='1.96889'
				y='3.71432'
				width='14.1433'
				height='14.1428'
				filterUnits='userSpaceOnUse'
				colorInterpolationFilters='sRGB'
			>
				<feFlood floodOpacity='0' result='BackgroundImageFix' />
				<feColorMatrix
					in='SourceAlpha'
					type='matrix'
					values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
					result='hardAlpha'
				/>
				<feOffset dy='1.28571' />
				<feGaussianBlur stdDeviation='0.964286' />
				<feComposite in2='hardAlpha' operator='out' />
				<feColorMatrix type='matrix' values='0 0 0 0 0.047839 0 0 0 0 0.549995 0 0 0 0 0.688889 0 0 0 1 0' />
				<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_7173_265' />
				<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_7173_265' result='shape' />
			</filter>
			<radialGradient
				id='paint0_radial_7173_265'
				cx='0'
				cy='0'
				r='1'
				gradientUnits='userSpaceOnUse'
				gradientTransform='translate(9.04018 14.4821) rotate(90) scale(10.6071 10.6545)'
			>
				<stop stopColor='#05F7DB' />
				<stop offset='1' stopColor='#1A8CFE' />
			</radialGradient>
			<radialGradient
				id='paint1_radial_7173_265'
				cx='0'
				cy='0'
				r='1'
				gradientUnits='userSpaceOnUse'
				gradientTransform='translate(9.04032 9.50003) rotate(90) scale(17.2483)'
			>
				<stop stopColor='white' />
				<stop offset='1' stopColor='#3154BE' />
			</radialGradient>
		</defs>
	</svg>
);
